module.exports = __webpack_public_path__ + "static/img/7.0694a5b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/1/eng/7.png
// module id = URI6
// module chunks = 0